import { useState } from "react";
import logo from "./Image/logo.png";
import domik from "./Image/domik.png";

// Обязательно добавь эти CSS-классы в index.css или global.css:
// .rotate-y-180 { transform: rotateY(180deg); }
// .backface-hidden { backface-visibility: hidden; }

export default function AnimatedLogo() {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="w-7 h-7 cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ perspective: 400 }}
    >
      <div
        className={`relative w-full h-full transition-transform duration-300 transform
          ${hovered ? "rotate-y-180" : ""}`}
        style={{
          transformStyle: "preserve-3d",
        }}
      >
        {/* Лицевая сторона (логотип) */}
        <img
          src={logo}
          alt="Логотип"
          className="absolute inset-0 w-full h-full object-contain backface-hidden"
          style={{ backfaceVisibility: "hidden" }}
          draggable={false}
        />
        {/* Обратная сторона (домик) */}
        <img
          src={domik}
          alt="Домик"
          className="absolute inset-0 w-full h-full object-contain backface-hidden"
          style={{ transform: "rotateY(180deg)", backfaceVisibility: "hidden" }}
          draggable={false}
        />
      </div>
    </div>
  );
}
